import request from '../../utils/request';

export default function spellCheck(text) {
  let API_ENDPOINT = '';
  const body = new FormData();

  if (text.length > 1) {
    API_ENDPOINT = '/checkTexts';
    const textArray = Array.isArray(text[0]) ? [].concat(...text) : text;
    textArray.forEach(textFragment => body.append('text', textFragment));
  } else {
    API_ENDPOINT = '/checkText';
    body.append('text', text);
  }

  const url = `https://speller.yandex.net/services/spellservice.json${API_ENDPOINT}`;

  return request(url, {
    method: 'POST',
    body,
  });
}
